<template>
  <div class="protocol_container">
    <div class="protocol_box">
      <div class="title_box">
        <div class="h2"><span>{{appFullName}}<br />网络服务使用协议</span></div>
      </div>
       <div class="content_box">
        <div class="block_box">
          <p>欢迎您使用“法治号”客户端软件及服务！</p>
          <p>为使用“法治号”客户端软件（以下简称“本软件”）及服务，您应当阅读并遵守《“法治号”客户端网络服务使用协议》（以下简称“本协议”）。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款，以及开通或使用某项服务的单独协议，并选择接受或不接受。限制、免责条款可能以加粗形式提示您注意。</p>
          <p>除非您已阅读并接受本协议所有条款，否则您无权下载、安装或使用本软件及相关服务。您的下载、安装、登录等使用行为即视为您已阅读并同意上述协议的约束。</p>
          <p>如果您未满18周岁，请在法定监护人的陪同下阅读本协议及其他上述协议，并特别注意未成年人使用条款。</p>
        </div>
        <div class="h4">
          <span>一、</span><span>【协议的范围】</span>
        </div>
        <div class="block_box">
          <p>1.1 【协议适用主体范围】</p>
          <p>本协议是您与法治日报社之间关于您下载、安装、使用、复制本软件，以及使用法治日报社相关服务所订立的协议。</p>
        </div>
        <div class="h4">
          <span>二、</span><span>【关于本服务】</span>
        </div>
        <div class="block_box">
          <p>2.1 【本服务的内容】</p>
          <p>本服务内容是指法治日报社向您提供的安装在包括但不限于移动电话、平板电脑等各种手持移动终端设备上，用于获取文字、图片、视频等信息、设置信息推送提醒、查看关注信息等功能的软件许可及服务（以下简称“本服务”）。</p>
          <p>2.2 【本服务的形式】</p>
          <p>本服务中“法治号”客户端软件提供包括但不限于IOS及Android等多个版本，您必须选择与所安装手机相匹配的软件版本。</p>
          <p>2.3 【本服务许可的范围】</p>
          <p>2.3.1 法治日报社给予您一项个人的、不可转让及非排他性的许可，以使用本软件。您可以为非商业目的在单一台终端设备上安装、使用、显示、运行本软件。</p>
          <p>2.3.2 您可以用计算机可读形式制作本软件的一个副本，仅用作备份。备份副本必须包含原软件中含有的所有知识产权信息。</p>
          <p>2.3.3 本条及本协议其他条款未明示授权的其他一切权利由法治日报社保留，您在行使这些权利时须另外取得法治日报社的书面许可。法治日报社如果未行使前述任何权利，并不构成对该权利的放弃。</p>
        </div>
        <div class="h4">
          <span>三、</span><span>【软件的获取】</span>
        </div>
        <div class="block_box">
          <p>3.1 您可以直接从法治日报社的网站上获取本软件，也可以从应用市场得到法治日报社授权的第三方获取。</p>
          <p>3.2 如果您从未经法治日报社授权的第三方获取本软件或与本软件名称相同的安装程序，法治日报社无法保证该软件能够正常使用，并对因此给您造成的损失不予负责。</p>
        </div>
        <div class="h4">
          <span>四、</span><span>【软件的安装与卸载】</span>
        </div>
        <div class="block_box">
          <p>4.1 法治日报社可能为不同的终端设备开发了不同的软件版本，您应当根据实际情况选择下载合适的版本进行安装。</p>
          <p>4.2 下载安装程序后，您需要按照该程序提示的步骤正确安装。</p>
          <p>4.3 如果您不再需要使用本软件或者需要安装新版软件，可以自行卸载。如果您愿意帮助法治日报社改进产品服务，请告知卸载的原因。</p>
        </div>
        <div class="h4">
          <span>五、</span><span>【软件的更新】</span>
        </div>
        <div class="block_box">
          <p>5.1 为了改善用户体验、完善服务内容，法治日报社将不断努力开发新的服务，并为您不时提供软件更新（这些更新可能会采取软件替换、修改、功能强化、版本升级等形式）。</p>
          <p>5.2 为了保证本软件及服务的安全性和功能的一致性，法治日报社有权不向您特别通知而对软件进行更新，或者对软件的部分功能效果进行改变或限制。</p>
          <p>5.3 本软件新版本发布后，旧版本的软件可能无法使用。法治日报社不保证旧版本软件继续可用及相应的客户服务，请您随时核对并下载最新版本。</p>
        </div>
        <div class="h4">
          <span>六、</span><span>【用户个人信息保护】</span>
        </div>
        <div class="block_box">
          <p>6.1 保护用户个人信息是法治日报社的一项基本原则，法治日报社将会采取合理的措施保护用户的个人信息。除法律法规规定的情形外，未经用户许可法治日报社不会向第三方公开、透露用户个人信息。为了向用户提供相关服务功能或改善技术和服务，您在注册账号或使用本服务的过程中，可能需要提供一些必要的信息。法治日报社对相关信息采用国际化标准的加密存储与传输方式，保障用户个人信息的安全。</p>
          <p>6.2 您在注册账号或使用本服务的过程中，可能需要提供一些必要的信息，例如：为向您提供账号注册服务，需要您填写电话号码等信息；若国家法律法规或政策有特殊规定的，您需要提供真实的身份信息。若您提供的信息不完整，则无法使用本服务或在使用过程中受到限制。</p>
          <p>6.3 法治日报社将运用各种安全技术和程序建立完善的管理制度来保护您的个人信息，以免遭受未经授权的访问、使用或披露。</p>
          <p>6.4 未经您的同意，法治日报社不会向法治日报社以外的任何公司、组织和个人披露您的个人信息，但法律法规另有规定的除外。</p>
          <p>6.5 法治日报社非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用法治日报社的服务前，应事先取得您家长或法定监护人的书面同意。</p>
        </div>
        <div class="h4">
          <span>七、</span><span>【主权利义务条款】</span>
        </div>
        <div class="block_box">
          <p>7.1 【帐号使用规范】</p>
          <p>法治日报社特别提醒您应妥善保管您的账号和密码。当您使用完毕后，应安全退出。因您保管不善可能导致遭受盗号或密码失窃等，责任由您自行承担。</p>
          <p>7.2 【用户注意事项】</p>
          <p>7.2.1 您理解并同意：为了向您提供有效的服务，您在此许可法治日报社利用您移动通讯终端设备的处理器和带宽等资源。本软件使用过程中可能产生数据流量的费用，您需自行向运营商了解相关资费信息。</p>
          <p>7.2.2 您理解并同意法治日报社将会尽其商业上的合理努力以保护您移动通讯终端与本软件及服务相关的资源及通讯的隐私性和完整性，但是，法治日报社并不能就此提供完全保证。</p>
          <p>7.2.3 您在使用本软件及服务时，须自行承担如下来自法治日报社不可掌控的风险内容，包括但不限于：</p>
          <p>7.2.3.1 由于您选择与所安装手机型号不相匹配的软件版本所导致的任何软件问题、手机问题或损害；</p>
          <p>7.2.3.2 您的手机隐私信息在使用本软件及服务时可能产生的信息安全风险；</p>
          <p>7.2.3.3 您在使用本软件访问第三方网站或信息系统时遇到内容质量及安全问题等；</p>
          <p>7.2.3.4 由于无线网络信号不稳定、无线网络带宽问题等原因，所引起的“法治号”客户端登录失败、资料同步不完整、页面打开速度慢等风险。</p>
        </div>
        <div class="h4">
          <span>八、</span><span>【用户行为规范】</span>
        </div>
        <div class="block_box">
          <p>8.1 【信息内容规范】</p>
          <p>8.1.1 您可使用本软件及服务发表属于您原创或您有权发表的观点看法、数据、文字、信息、用户名、图片、照片、个人信息、音频、视频文件、链接等信息内容。您必须保证，您拥有您所上传信息内容的知识产权或已获得合法授权，您使用本软件及服务的任何行为未侵犯任何第三方之合法权益。</p>
          <p>8.1.2 您在使用本服务时需遵守法律法规、社会主义制度、国家利益、公民合法权益、社会公共秩序、道德风尚及信息真实性等“七条底线”要求。</p>
          <p>8.1.3 您在使用本服务时不得利用本服务从事以下行为，包括但不限于：</p>
          <p>8.1.3.1 制作、复制、发布、传播、储存违反国家法律法规的内容：</p>
          <p>（1） 反对宪法所确定的基本原则的；</p>
          <p>（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
          <p>（3）损害国家荣誉和利益的；</p>
          <p>（4）煽动民族仇恨、民族歧视，破坏民族团结的；</p>
          <p>（5）破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
          <p>（6）散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
          <p>（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
          <p>（8）侮辱或者诽谤他人，侵害他人合法权益的；</p>
          <p>（9）煽动非法集会、结社、游行、示威、聚众扰乱社会秩序；</p>
          <p>（10）以非法民间组织名义活动的；</p>
          <p>（11）含有法律、行政法规禁止的其他内容的。</p>
          <p>8.1.3.2 发布、传送、传播、储存侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容；</p>
          <p>8.1.3.3 虚构事实、隐瞒真相以误导、欺骗他人；</p>
          <p>8.1.3.4 发表、传送、传播广告信息及垃圾信息；</p>
          <p>8.1.3.5 从事其他违反法律法规、政策及公序良俗、社会公德等的行为。</p>
          <p>8.2 【软件使用规范】</p>
          <p>除非法律允许或法治日报社书面许可，您使用本软件过程中不得从事下列行为：</p>
          <p>8.2.1 删除本软件及其副本上关于知识产权的信息；</p>
          <p>8.2.2 对本软件进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现本软件的源代码；</p>
          <p>8.2.3 对法治日报社拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；</p>
          <p>8.2.4 对本软件或者本软件运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及本软件运行所必需的系统数据，进行复制、修改、增加、删除、挂接运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非法治日报社经授权的第三方工具/服务接入本软件和相关系统；</p>
          <p>8.2.5 通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；</p>
          <p>8.2.6 通过非法治日报社开发、授权的第三方软件、插件、外挂、系统，登录或使用法治日报社软件及服务，或制作、发布、传播上述工具；</p>
          <p>8.2.7 其他未经法治日报社明示授权的行为。</p>
          <p>8.3 【对自己行为负责】</p>
          <p>您充分了解并同意，您必须为自己注册账号下的一切行为负责，包括您所发表的任何内容以及由此产生的任何后果。您应对本服务中的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。法治日报社无法且不会对因前述风险而导致的任何损失或损害承担责任。</p>
          <p>8.4 【违约处理】</p>
          <p>8.4.1 如果法治日报社发现或收到他人举报或投诉用户违反本协议约定的，法治日报社有权不经通知随时对相关内容进行删除，并视行为情节对违规账号处以包括但不限于警告、限制或禁止使用全部或部分功能、账号封禁直至注销的处罚，并公告处理结果。</p>
          <p>8.4.2 您理解并同意，法治日报社有权依合理判断对违反有关法律法规或本协议规定的行为进行处罚，对违法违规的任何人士采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，用户应独自承担由此而产生的一切法律责任。</p>
          <p>8.4.3 您理解并同意，因您违反本协议或相关服务条款的规定，导致或产生第三方主张的任何索赔、要求或损失，您应当独立承担责任；法治日报社因此遭受损失的，您也应当一并赔偿。</p>
          <p>8.5 【网络服务使用协议】</p>
          <p>8.5.1 用户在“法治号”客户端注册或游客发言前，请认真阅读本条例。一经注册或发言，即视为同意接受本条例；如不同意，请勿注册或发言。</p>
          <p>您必须在完全同意如下条款的前提下，才能进行会员注册程序，您只有在成为“法治号”客户端会员后，才能使用我们所提供的服务。用户在享受“法治号”客户端服务时必须完全、严格遵守本服务条款。</p>
          <p>8.5.2 “法治号”客户端根据互联网的发展和中华人民共和国有关法律、法规的变化，不断地完善服务质量并依此修改“法治号”客户端会员服务条款。用户的权利以及义务的表述，均以最新的服务条款为准。“法治号”客户端保留随时修改或中断服务而不需通知您的权利，“法治号”客户端行使修改或中断服务的权利，不需对您或第三方负责。</p>
          <p>8.5.3 “法治号”客户端会员在注册会员资格时，所提交的资料必须真实有效，否则“法治号”客户端有权拒绝其申请或者撤销其会员资格，并不予任何赔偿。会员的个人资料发生变化时，应及时修改注册的个人资料，否则由此造成的会员权利不能全面有效地行使的责任由会员自己承担，“法治号”客户端有权因此取消其会员资格，并不予任何赔偿。</p>
          <p>8.5.4 本会员资格只限本用户名使用，不得转让到其他用户名上。若会员违反本服务条款的规定，“法治号”客户端将有权取消该会员的会员资格而无须给予任何补偿。</p>
          <p>8.5.5 会员对本服务条款的修改有任何异议，可自动放弃会员资格。</p>
          <p>8.5.6 会员必须妥善保管其用户名及密码，因密码被盗或泄露造成的全部责任和损失均由您本人承担，“法治号”客户端概不负责。用户因忘记密码或密码被盗向“法治号”客户端查询密码时，必须提供完全正确的注册信息，否则“法治号”客户端有权本着为会员保密的原则不予告知。</p>
          <p>8.5.7 会员的用户名和密码只能供会员本人使用，不得以任何形式转让或授权他人使用，如果发现同一账号和密码在同一时间内被多人同时登录使用，“法治号”客户端有权取消此账号的会员资格，并不予任何赔偿。</p>
          <p>8.5.8 会员用户名中不得含有任何威胁、恐吓、漫骂、庸俗、亵渎、色情、淫秽、非法、反动、前后矛盾、攻击性、伤害性、骚扰性、诽谤性、辱骂性的或侵害他人知识产权的文字。</p>
          <p>8.5.9 尊重会员的个人隐私是“法治号”客户端的一项基本政策，“法治号”客户端保证不公开或披露会员的个人信息，也不会私自更改会员的注册信息。</p>
          <p>8.5.10 您须明确同意“法治号”客户端所有网络平台的使用由您个人承担风险。“法治号”客户端明确表示不提供任何类型的担保，不论是明确的或隐含的。</p>
          <p>8.5.11 “法治号”客户端不担保所提供的服务一定能满足您的要求，也不担保服务不会中断，对服务的及时性、安全性、错误发生都不作担保。“法治号”客户端拒绝提供任何担保，包括信息能否准确、及时、顺利地传送。</p>
          <p>8.5.12 您理解并接受任何信息资料(下载或通过服务取得)，取决于您自己并由您承担系统受损或资料丢失的所有风险和责任。您不会从“法治号”客户端收到口头或书写的意见或信息。</p>
          <p>8.5.13 “法治号”客户端对任何直接、间接、偶然、特殊及继起的损害不负责任，不予赔偿。这些损害来自：网络故障；不正当下载、使用“法治号”客户端服务内容；在网上购买商品或类似服务；在网上进行交易，非法使用服务等。</p>
          <p>8.5.14 会员在使用“法治号”客户端所提供的服务时，如遭受任何人身或财务的损失、损害或伤害，不论原因如何，“法治号”客户端均不负责任。由于用户将个人密码告知他人或与他人共享注册账户，由此导致的任何个人资料泄露，“法治号”客户端不负任何责任。</p>
          <p>8.5.15 会员须对其自身在使用“法治号”客户端所提供的服务时的一切行为、行动（不论是否故意）负全部责任，包括但不限于违反国家相关法律、法规的规定及侵犯其他第三方的合法权益等。</p>
          <p>8.5.16 用户应对自己在“法治号”客户端上发表的内容负全部责任，并承诺提交的姓名、身份证号码、常住地址、联系方式等个人资料真实可靠。</p>
          <p>8.5.17 对于因服务器的死机、网络的故障、数据库故障、软件升级等问题造成的服务中断和对会员个人数据及资料造成的损失，“法治号”客户端不负责任，亦不予补偿。</p>
          <p>8.5.18 当政府司法机关依照法定程序要求“法治号”客户端披露个人资料时，我们将根据执法单位之要求或为公共安全之目的提供个人资料。在此情况下之任何披露，“法治号”客户端均得免责。</p>
          <p>8.5.19 因发生不可抗拒的事由，如政府行为、不可抗力，导致会员服务无法继续提供，“法治号”客户端将尽快通知您，但不承担由此对您造成的任何损失。如用户违反被服务条款中的内容，“法治号”客户端有权取消用户的会员资格，并中止向其继续提供服务。</p>
          <p>8.5.20 “法治号”客户端提供的会员服务内容（包括但不限于：文字、照片、图形、图像、图表、声音、H5、FLASH 动画、直播、视频、音频等），均受版权保护：由“法治号”客户端版权所有，或由第三方授权使用。用户不能擅自复制、再造这些内容、或创造与内容有关的派生产品。凡以任何方式登录“法治号”客户端或直接、间接使用资料者，视为自愿接受“法治号”客户端声明的约束。本声明未涉及的问题参见国家有关法律法规，当本声明与国家法律法规冲突时，以国家法律法规为准。本声明以及其修改权、更新权及最终解释权均属《法治日报社》所有。</p>
          <p>8.5.21 用户要注意保管好用户名及密码。因黑客行为或用户保管疏忽导致账号、密码遭他人非法使用，“法治号”客户端不承担任何责任。</p>
          <p>8.5.22 用户需遵守网络道德，注意网络礼仪，做到文明上网。</p>
        </div>
        <div class="h4">
          <span>九、</span><span>【知识产权声明】</span>
        </div>
        <div class="block_box">
          <p>9.1 法治日报社是本软件的知识产权权利人。本软件的一切著作权、商标权、专利权、商业秘密等知识产权，以及与本软件相关的所有信息内容（包括但不限于文字、图片、音频、视频、图表、界面设计、版面框架、有关数据或电子文档等）均受中华人民共和国法律法规和相应的国际条约保护，法治日报社享有上述知识产权。</p>
          <p>9.2 未经法治日报社或相关权利人书面同意，您不得为任何商业或非商业目的自行或许可任何第三方实施、利用、转让上述知识产权。</p>
        </div>
        <div class="h4">
          <span>十、</span><span>【终端安全责任】</span>
        </div>
        <div class="block_box">
          <p>10.1 您理解并同意，本软件同大多数互联网软件一样，可能会受多种因素影响，包括但不限于用户原因、网络服务质量、社会环境等；也可能会受各种安全问题的侵扰，包括但不限于他人非法利用用户资料，进行现实中的骚扰；用户下载安装的其他软件或访问的其他网站中可能含有病毒、木马程序或其他恶意程序，威胁到您的终端设备信息和数据安全，继而影响本软件的正常使用等。因此，您应加强信息安全及个人信息的保护意识，注意密码保护，以免遭受损失。</p>
          <p>10.2 维护软件安全与正常使用是法治日报社和您的共同责任，法治日报社将按照行业标准合理审慎地采取必要技术措施保护您的终端信息和数据安全，但是您承认和同意法治日报社并不能就此提供完全保证。</p>
        </div>
        <div class="h4">
          <span>十一、</span><span>【第三方软件或技术】</span>
        </div>
        <div class="block_box">
          <p>11.1 本软件可能会使用第三方软件或技术（包括本软件可能使用的开源代码和公共领域代码等，下同），这种使用已经获得合法授权，本软件应遵循相应的开源协议，对应的开源协议请参见本协议附件。</p>
          <p>11.2 本软件如果使用了第三方的软件或技术，法治日报社将按照相关法规或约定，对相关的协议或其他文件，可能通过本协议附件、在本软件安装包特定文件夹中打包等形式进行展示，它们可能会以“软件使用许可协议”、“授权协议”、“开源代码许可证”或其他形式来表达。前述通过各种形式展现的相关协议或其他文件，均是本协议不可分割的组成部分，与本协议具有同等的法律效力，您应当遵守这些要求。如果您没有遵守这些要求，该第三方或者国家机关可能会对您提起诉讼、罚款或采取其他制裁措施，并要求法治日报社给予协助，您应当自行承担法律责任。</p>
          <p>11.3 如因本软件使用的第三方软件或技术引发的任何纠纷，应由该第三方负责解决，法治日报社不承担任何责任。法治日报社不对第三方软件或技术提供客服支持，若您需要获取支持，请与第三方联系。</p>
        </div>
        <div class="h4">
          <span>十二、</span><span>【其他】</span>
        </div>
        <div class="block_box">
          <p>12.1 您使用本软件即视为您已阅读并同意受本协议的约束。法治日报社有权在必要时修改本协议条款。您可以在本软件的最新版本中查阅相关协议条款。本协议条款变更后，如果您继续使用本软件，即视为您已接受修改后的协议。如果您不接受修改后的协议，应当停止使用本软件。</p>
          <p>12.2 本协议签订地为中华人民共和国北京市。</p>
          <p>12.3 本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。</p>
          <p>12.4 若您和法治日报社之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。</p>
          <p>12.5 本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。</p>
          <p>12.6 本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。</p>
          <p><br></p>
          <p class="bottom_date">
            <span>法治日报社</span>
          </p>
          <p class="bottom_date">
            <span>2022年3月5日</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { loadStat } from "@/utils";
import commApi from "@/api/apis/common.js";
export default {
  name: "Protocol",
  data() {
    return {};
  },
  computed: {
    ...mapState("app", ["nodeCode", "appFullName"]),
  },
  methods: {
    /* 微信二次分享 */
    wechatShare() {
      var _this = this;

      commApi.getWeiXinTicket({
        nodeCode: _this.nodeCode,
        url: location.href
      }).then((res) => {
        _this.$WeiXin.shareWeiXin(res, _this.appFullName + "网络服务使用协议", _this.appFullName, location.href);
      }).catch((err) => {

      })
    },
  },
  created() {
    document.title = this.appFullName + "网络服务使用协议";
    this.wechatShare(); // 微信二次分享
    loadStat(); // 友盟统计
  },
};
</script>
<style scoped lang="scss">
.protocol_container {
  width: 100%;
  height: 100%;
  padding: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .protocol_box {
    padding: 15px;
    overflow-x: hidden;
    overflow-y: auto;
    * {
      word-break: normal;
      white-space: normal;
      line-height: 1.5em;
      font-family: "Microsoft Yahei";
    }
    .title_box {
      .h2 {
        padding: 18px 0;
        line-height: 27px;
        text-align: center;
        color: #000;
        font-size: 18px;
        font-weight: bolder;
      }
    }
    .content_box {
      .h4 {
        margin-top: 15px;
        color: #000;
        font-family: "Microsoft Yahei";
        font-size: 18px;
        span {
          color: #000;
          font-family: "Microsoft Yahei";
          font-weight: bolder;
        }
      }
      p {
        line-height: 27px;
        margin: 10px 0;
        color: #000;
        font-family: "Microsoft Yahei";
        font-size: 16px;
        text-indent: 2em;
        text-align: justify;
        * {
          color: #000;
          font-family: "Microsoft Yahei";
          text-align: justify;
        }
        &.bottom_date {
          margin: 5px 0;
          text-align: right;
        }
      }
    }
  }
}
</style>